import React from 'react'
import Navbar from '../inc/Navbar'
import StudentForm from './StudentFrom'

function Studentpage() {
  return (
    <div>
      <Navbar/>
      <br/>
      <br/>
      <br/>
      <br/>
      <StudentForm/>
      <br/>
    </div>
  )
}

export default Studentpage